import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, REQUEST_TYPE, } from './types';
import { closeFrozenErrorModal, 
// closeErrorModal,
enhanceLimit, getURL, goBack, navigateToPledgeHistoryPage, navigateToRemovePledgeSteps, navigateToUnpledege, navigation, viewDetails } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { api } from '../../../configs/api';
import { CreditApplicationType, getAppHeader } from '../../../configs/config';
import { removeUrlWithoutReload, showLeinRemovalTrackingFlow } from '../../../configs/utils';
import { QUERY_PARAMS, TARGET_PAGES } from '../../../configs/constants';
import sharedPropsService from "../../../SharedPropsService";
export const template = (creditStatus, platform, height, creditResponse, tempData, creditAmount, showIncreaseLimit, showUnpledge, allowRemovePledge, unpledgeStatus, loanNotOpenedForPledgeMore, loanNotOpenedForRemovePledge, showLeinRemovalTracking, extraOutstandingBufferBajaj, fundAmount, extraOutstandingBufferDsp, isLoanExpired, isFromForeclosureRasonPage) => {
    return {
        layout: {
            id: ROUTE.VIEW_PORTFOLIO_DETAIL,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "manageLimit", type: WIDGET.VIEW_PORTFOLIO }
            ],
        },
        datastore: {
            manageLimit: {
                height: height,
                bankData: creditResponse,
                tempData,
                creditLimit: creditAmount,
                fundAmount,
                showIncreaseLimit: showIncreaseLimit,
                showUnpledege: showUnpledge,
                allowUnpledge: allowRemovePledge,
                isFromForeclosureRasonPage,
                viewDetailsAction: {
                    type: ACTION.VIEW_DETAILS,
                    routeId: ROUTE.VIEW_PORTFOLIO_DETAIL,
                    payload: {},
                },
                backAction: {
                    type: ACTION.MENU,
                    routeId: ROUTE.VIEW_PORTFOLIO_DETAIL,
                    payload: { isFromForeclosureRasonPage }
                },
                skipBankAction: {
                    type: ACTION.EMAIL,
                    routeId: ROUTE.VIEW_PORTFOLIO_DETAIL,
                },
                applyAction: {
                    type: ACTION.NAVIGATE_UNPLEDGE,
                    //payload: <PhoneNumberPayload>{ value: "", widgetId: "input" },
                    routeId: ROUTE.VIEW_PORTFOLIO_DETAIL,
                },
                continuePress: {
                    type: ACTION.ENHANCE_LIMIT,
                    payload: {
                        applicationType: CreditApplicationType.CREDIT_MODIFICATION_AGAINST_SECURITIES,
                    },
                    routeId: ROUTE.VIEW_PORTFOLIO_DETAIL,
                },
                directRemovePledgeStepsAction: {
                    type: ACTION.NAVIGATE_TO_REMOVE_PLEDGE_STEPS,
                    payload: { extraOutstandingBufferBajaj, extraOutstandingBufferDsp },
                    routeId: ROUTE.VIEW_PORTFOLIO_DETAIL,
                },
                navigateToPledgeHistoryAction: {
                    type: ACTION.NAVIGATE_TO_PLEDGE_HISTORY,
                    payload: {},
                    routeId: ROUTE.VIEW_PORTFOLIO_DETAIL,
                },
                unpledgeData: unpledgeStatus,
                loanNotOpenedForPledgeMore: loanNotOpenedForPledgeMore,
                loanNotOpenedForRemovePledge: loanNotOpenedForRemovePledge,
                showLeinRemovalTracking: showLeinRemovalTracking,
                showRemovePledgeModal: false,
                showErrorModal: false,
                showLoader: false,
                extraOutstandingBufferBajaj,
                extraOutstandingBufferDsp,
                isLoanExpired,
                showFrozenErrorModal: false,
                closeFrozenErrorModalAction: {
                    type: ACTION.CLOSE_FROZEN_ERROR_MODAL,
                    payload: {},
                    routeId: ROUTE.VIEW_PORTFOLIO_DETAIL,
                }
            },
        },
    };
};
export const viewPortfolioDetail = {
    onLoad: async ({ getHeight, instrumentTrack, network }, { target, tempData, isFromForeclosureRasonPage }) => {
        const creditStatus = await SharedPropsService.getCreditStatus();
        const user = await SharedPropsService.getUser();
        const creditAmount = await SharedPropsService.getTotalCreditAmount();
        const fundAmount = await SharedPropsService.getTotalFundAmount();
        const extraOutstandingBufferBajajFB = await SharedPropsService.getFirebaseConfig()?.extra_outstanding_buffer || "0";
        const extraOutstandingBufferDspFB = await SharedPropsService.getFirebaseConfig()?.extra_outstanding_buffer_dsp || "0";
        const extraOutstandingBufferBajaj = Number(extraOutstandingBufferBajajFB);
        const extraOutstandingBufferDsp = Number(extraOutstandingBufferDspFB);
        const requestOptions = {
            method: 'GET',
            headers: await getAppHeader(),
        };
        if (target && target === TARGET_PAGES.MANAGE_LIMIT) {
            removeUrlWithoutReload(QUERY_PARAMS.TARGET);
        }
        const unpledgeStatus = await network.get(`${api.getRevocationByCredit}/${user.linkedCredits[0].creditId}`, {
            headers: await getAppHeader(),
        });
        const allowRemovePledge = unpledgeStatus.data.length === 0;
        const creditId = user.linkedCredits[0].creditId;
        const getPledgeHistoryResponse = await network.get(`${api.getPledgeHistory}${creditId}?creditRequestTypes=${REQUEST_TYPE.REVOCATION_REQUEST}%2C${REQUEST_TYPE.ENHANCE_LIMIT_REQUEST}`, {
            headers: await getAppHeader(),
        });
        const pledgeHistoryData = getPledgeHistoryResponse?.data;
        const enhanceLimitRequestDetailsList = pledgeHistoryData?.enhanceLimitRequestDetailsList;
        const revocationRequestDetailsList = pledgeHistoryData?.revocationRequestDetailsList;
        const manageLimitConfig = await network
            .get(`${api.manageLimitConfig}${user.linkedCredits[0].creditId}`, requestOptions).then(response => response.data);
        const showIncreaseLimit = manageLimitConfig.increaseLimitAllowed;
        const showDecreaseLimit = manageLimitConfig.decreaseLimitAllowed;
        const creditResponse = await SharedPropsService.getPortfiolioData();
        const loanNotOpenedForPledgeMore = enhanceLimitRequestDetailsList.length === 0 && showIncreaseLimit === false;
        const loanNotOpenedForRemovePledge = revocationRequestDetailsList.length === 0 && showDecreaseLimit === false;
        const showLeinRemovalTracking = await showLeinRemovalTrackingFlow();
        instrumentTrack('PLEDGED_MUTUAL_FUNDS_PAGE_VIEWED', {
            source_page: 'MANAGE_LIMIT',
        });
        const platform = await sharedPropsService.getAppPlatform();
        const isLoanExpired = await SharedPropsService.getIsLoanExpired();
        return Promise.resolve(template(creditStatus, platform, getHeight(), creditResponse || [], tempData, creditAmount, showIncreaseLimit, showDecreaseLimit, allowRemovePledge, unpledgeStatus.data, loanNotOpenedForPledgeMore, loanNotOpenedForRemovePledge, showLeinRemovalTracking, extraOutstandingBufferBajaj, fundAmount, extraOutstandingBufferDsp, isLoanExpired, isFromForeclosureRasonPage));
    },
    actions: {
        [ACTION.EMAIL]: getURL,
        [ACTION.NAVIGATION]: navigation,
        [ACTION.MENU]: goBack,
        [ACTION.ENHANCE_LIMIT]: enhanceLimit,
        [ACTION.MARGIN_CALL]: enhanceLimit,
        [ACTION.NAVIGATE_UNPLEDGE]: navigateToUnpledege,
        [ACTION.VIEW_DETAILS]: viewDetails,
        [ACTION.NAVIGATE_TO_REMOVE_PLEDGE_STEPS]: navigateToRemovePledgeSteps,
        [ACTION.NAVIGATE_TO_PLEDGE_HISTORY]: navigateToPledgeHistoryPage,
        [ACTION.CLOSE_FROZEN_ERROR_MODAL]: closeFrozenErrorModal,
        // [ACTION.CLOSE_ERROR_MODAL] : closeErrorModal,
    },
};
